import { render, staticRenderFns } from "./RegistrationFormComponent.vue?vue&type=template&id=1f209ac7"
import script from "./RegistrationFormComponent.js?vue&type=script&lang=js&external"
export * from "./RegistrationFormComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports